export type ViewerTab = "snapshot" | "3d";

export function resolveViewerTab(
  lastPickedTab: ViewerTab,
  hasSnapshot: boolean,
): ViewerTab {
  if (!hasSnapshot) return "3d";
  return lastPickedTab;
}
